import { render, staticRenderFns } from "./Games.vue?vue&type=template&id=9b1da5d8&scoped=true&"
import script from "./Games.vue?vue&type=script&lang=js&"
export * from "./Games.vue?vue&type=script&lang=js&"
import style0 from "./Games.vue?vue&type=style&index=0&id=9b1da5d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b1da5d8",
  null
  
)

export default component.exports